// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9224f25b","495":"5f0cc2f0","500":"8e42ab52","859":"4a6c1f25","926":"769e8cba"}[chunkId] + ".chunk.js";
};